export default {
    'name': 'caret-slider',
    'width': '80',
    'height': '80',
    'viewBox': '0 0 80 80',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M60.024 53.3675C60.805 54.1486 62.0713 54.1486 62.8524 53.3675C63.6334 52.5865 63.6334 51.3201 62.8524 50.5391L39.4602 27.1468C39.0851 26.7717 38.5764 26.561 38.0459 26.561C37.5155 26.561 37.0068 26.7717 36.6317 27.1468L13.2395 50.5391C12.4584 51.3201 12.4584 52.5865 13.2395 53.3675C14.0205 54.1486 15.2869 54.1486 16.0679 53.3675L38.0459 31.3895L60.024 53.3675Z\' fill=\'#FF4171\'/>'
}
